import {EnumType, JacksonType, JsonIdentityInfo, JsonSubType} from "@sonner/jackson-service-v2";
import {AlertaFiscal} from "./alerta.fiscal";
import {PapelServicoEnum} from "../enums/papel.servico.enum";

@JacksonType("AlertaFiscalTributacaoExcessivaFora")
@JsonSubType({key: 'br.com.sonner.iss.entity.dw.AlertaFiscalTributacaoExcessivaFora', type: 'AlertaFiscal'})
@JsonIdentityInfo()
export class AlertaFiscalTributacaoExcessivaFora extends AlertaFiscal {

  @EnumType(PapelServicoEnum)
  papel: PapelServicoEnum;

  valorMedio: number;

  valorReceita: number;
}
